import UIInterceptor from '@/UIInterceptors/UIInterceptor';
import ComponentManager from '@/Management/ComponentManager';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import InlineEditingGridManager from '@/Components/InlineEditingGrid/InlineEditingGridManager';
import UrlLinkPrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/UrlLinkPrinter';
import EmbeddedMediumLinkPrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/EmbeddedMediumLinkPrinter';
import NumericPrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/NumericPrinter';
import CurrencyPrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/CurrencyPrinter';
import BoolPrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/BoolPrinter';
import DateTimePrinter from '@/Components/InlineEditingGrid/ReadOnlyPrinter/DateTimePrinter';

export default class DefaultConfigurationInterceptor extends UIInterceptor {

    constructor() {
        super();
    }

    public afterStartup(callback: Function): void {

        this.pushToConfiguration('visitedModules', 'DefaultViewExtensions');

        this.addInlineReplacements();

        callback();
    }

    private pushToConfiguration(name: string, value: any) {
        if (!GlobalConfiguration[name]) {
            GlobalConfiguration[name] = [];
        }

        GlobalConfiguration[name].push(value);
    }

    private addInlineReplacements(): void {
        InlineEditingGridManager.registerUIGeneratorReplacerCallback('MLStringBox', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'InlineLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacerCallback('MLStringPopupBox', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'InlineLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacerCallback('TextBox', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'InlineLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacerCallback('EnumerationComboBox', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'InlineLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacerCallback('AssoziationDropDown', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'AssoziationLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacerCallback('AssociationMultiDropDown', (parameter, dvgItem) => {
            if (dvgItem.guiReadOnly || (dvgItem.isDerived && !dvgItem.isDerivedOverwritable))
                parameter.uiGenerator = 'AssociationMultiLabel'

            return parameter;
        });

        InlineEditingGridManager.registerUIGeneratorReplacer('AssociationSingleDropDown', 'ExtIEGAssociationSingleDropdown');
        InlineEditingGridManager.registerUIGeneratorReplacer('AssoziationDropDown', 'ExtIEGAssociationSingleDropdown');
        InlineEditingGridManager.registerUIGeneratorReplacer('AssociationGrid', 'ExtIEGAssociationGrid');
        InlineEditingGridManager.registerUIGeneratorReplacer('AssoziationGrid', 'ExtIEGAssociationGrid');

        InlineEditingGridManager.registerUIGeneratorReplacer('Label', 'InlineLabel', true);
        InlineEditingGridManager.registerUIGeneratorReplacer('MLStringLabel', 'InlineLabel', true);

        InlineEditingGridManager.registerTextColumnFactory('InlineLabel');
        InlineEditingGridManager.registerTextColumnFactory('DateTimeLabel');
        InlineEditingGridManager.registerTextColumnFactory('AssociationLabel');
        InlineEditingGridManager.registerTextColumnFactory('AssoziationLabel');
        InlineEditingGridManager.registerTextColumnFactory('AssociationMultiLabel');
        InlineEditingGridManager.registerTextColumnFactory('AssoziationMultiLabel');
        InlineEditingGridManager.registerTextColumnFactory('EnumerationLabel');
        InlineEditingGridManager.registerTextColumnFactory('CheckBoxLabel');
        InlineEditingGridManager.registerTextColumnFactory('CheckBox');

        InlineEditingGridManager.registerReadOnlyPrinter(UrlLinkPrinter);
        InlineEditingGridManager.registerReadOnlyPrinter(EmbeddedMediumLinkPrinter);
        // Muss vor NumericPrinter registriert werden! Andernfalls gewinnt immer der NumericPrinter!
        InlineEditingGridManager.registerReadOnlyPrinter(CurrencyPrinter);
        InlineEditingGridManager.registerReadOnlyPrinter(NumericPrinter);
        InlineEditingGridManager.registerReadOnlyPrinter(BoolPrinter);
        InlineEditingGridManager.registerReadOnlyPrinter(DateTimePrinter);
    }
}

ComponentManager.setUIInterceptor('DefaultConfigurationInterceptor', DefaultConfigurationInterceptor, 'RADPresentation.HTMLClient.DefaultViewExtensions');